import { render, staticRenderFns } from "./barangjadi.vue?vue&type=template&id=27053fc1&scoped=true&"
import script from "./barangjadi.vue?vue&type=script&lang=js&"
export * from "./barangjadi.vue?vue&type=script&lang=js&"
import style0 from "./barangjadi.vue?vue&type=style&index=0&id=27053fc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27053fc1",
  null
  
)

export default component.exports